import { render } from "./CourseDetails3.vue?vue&type=template&id=2301887a&scoped=true"
import script from "./CourseDetails3.vue?vue&type=script&lang=js"
export * from "./CourseDetails3.vue?vue&type=script&lang=js"

import "./CourseDetails3.vue?vue&type=style&index=0&id=2301887a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2301887a"]])

export default __exports__